<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            [style]="(`height: calc(100vh - ${offset}px)`)"
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'vendors-grid-state', savingTimeout: 0 }"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Vendors</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item location="after" locateInMenu="never">
                    <dx-button
                        class="ms-sm-2"
                        text="New"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        [visible]="canEdit"
                        (onClick)="addVendor()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>
            <dxi-column [dataField]="gridFieldName('number')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>
            <dxi-column [dataField]="gridFieldName('name')" caption="Name" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('serviceTypeName')" caption="Service Type" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('sites')" caption="Site" [minWidth]="150" [calculateCellValue]="sitesCellValue"
                [allowSorting]="false" [allowFiltering]="false" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column [dataField]="gridFieldName('address')" caption="Address" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('phone')" caption="Phone #" [minWidth]="100" cellTemplate="phone"></dxi-column>
            <dxi-column [dataField]="gridFieldName('email')" caption="Email" [minWidth]="100"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" [lookup]="{ dataSource: vendorStatusOptions, valueExpr: 'value', displayExpr: 'text' }"
                caption="Status" [filterOperations]="['=']" [headerFilter]="{ dataSource: vendorStatusOptions }" [minWidth]="150" cellTemplate="status"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('term')" [lookup]="{ dataSource: vendorTermOptions, valueExpr: 'value', displayExpr: 'text' }"
                caption="Term" [filterOperations]="['=']" [headerFilter]="{ dataSource: vendorTermOptions }" [minWidth]="150" [visible]="false"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('contractExpirationDate')" dataType="date" caption="Contract Expiration Date" cellTemplate="date" [minWidth]="100" selectedFilterOperation=">="></dxi-column>
            <dxi-column dataField="lastModifiedBy.name" caption="Last Modified By" cellTemplate="lastModifiedBy"
                [visible]="false" [minWidth]="250" [calculateFilterExpression]="lastModifiedByFilter"></dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" dataType="date" caption="Last Modified" [minWidth]="150" cellTemplate="dateTime" [visible]="false" selectedFilterOperation=">="></dxi-column>
            <dxi-column dataField="createdBy.name" caption="Created By" cellTemplate="createdBy"
                [visible]="false" [minWidth]="250" [calculateFilterExpression]="createdByFilter"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" dataType="date" caption="Created" cellTemplate="dateTime" [minWidth]="150" [visible]="false" [sortOrder]="'desc'" selectedFilterOperation=">="></dxi-column>

            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit"></dxi-button>
                <dxi-button text="delete" icon="trash" hint="delete" [onClick]="onDelete" [visible]="canManage"></dxi-button>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'id'">
                <div class="text-primary fw-semibold">
                    {{ getCellData(cellInfo).number }}
                </div>
            </div>
            <div *dxTemplate="let cellInfo of 'status'">
                <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                    {{ cellInfo.value | capitalCase }}
                </span>
            </div>
            <div *dxTemplate="let cellInfo of 'phone'">
                {{ getCellData(cellInfo).phone | phoneFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'date'">
                {{ cellInfo.value | date:dateFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'dateTime'">
                {{ cellInfo.value | date:dateTimeFormat }}
            </div>
            <div *dxTemplate="let cellInfo of 'lastModifiedBy'">
                @if (getCellData(cellInfo).lastModifiedBy; as lastModifiedBy) {
                    <user-avatar-email
                        [email]="lastModifiedBy.email"
                        [name]="lastModifiedBy.name"
                        [avatarUrl]="lastModifiedBy.avatarUrl"
                        [employeeId]="lastModifiedBy.id"
                    ></user-avatar-email>
                }
            </div>
            <div *dxTemplate="let cellInfo of 'createdBy'">
                @if (getCellData(cellInfo).createdBy; as createdBy) {
                    <user-avatar-email
                        [email]="createdBy.email"
                        [name]="createdBy.name"
                        [avatarUrl]="createdBy.avatarUrl"
                        [employeeId]="createdBy.id"
                    ></user-avatar-email>
                }
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('number')"  editorType="dxTextBox" caption="ID" [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}"></dxi-item>
            <dxi-item [dataField]="filterModelName('name')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('serviceTypeName')" [label]="{ text: 'Service Type' }" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Service Type', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('address')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Address', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('phone')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Phone', stylingMode: 'filled', mask: '(000) 000-0000' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('email')" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Email', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('status')" editorType="dxSelectBox" [editorOptions]="{ items: vendorStatusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('term')" editorType="dxSelectBox" [editorOptions]="{ items: vendorTermOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Term', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('contractExpirationDate')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Contract Expiration Date', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="'lastModifiedBy.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Last Modified By', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('lastModified')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Last Modified', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="'createdBy.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Created By', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"></dxi-item>
        </dx-form>
    </filter-panel>
    <vendor-form [(visible)]="isVendorPopupOpened" [vendorId]="vendorId" [isReadOnly]="!canEdit" (onSave)="onSave()"></vendor-form>
</div>
